// extracted by mini-css-extract-plugin
module.exports = {"button":"Search_button__1NuCM","group":"Search_group__LKR-6"};